module.exports = __webpack_public_path__ + "static/media/Person6.083f7d98.png";